<template>
  <WorkerList/>
</template>

<script>
import WorkerList from '@/components/Workers/WorkerList.vue';

export default {
  components: {
    WorkerList,
  },
};
</script>
